/**
 * 공개 마케팅 페이지(랜딩/OnPremise/Pricing/About 등) 에서 사용.
 * 하드코드된 짙은 배경 + 그라디언트 텍스트 디자인 때문에 라이트 모드로 전환 시
 * 가독성이 붕괴되므로 해당 페이지 방문 동안 강제로 다크 테마를 유지한다.
 *
 * 언마운트 시: 스냅샷이 아니라 실제 테마 스토어 상태(스탠다드=라이트)로 복원한다.
 * (스냅샷 복원은 네비게이션 타이밍에 따라 다크가 새어나가는 버그가 있었음)
 */
import { useEffect } from 'react'
import { useThemeStore } from '../../store/themeStore'

export default function ForceDarkTheme() {
  useEffect(() => {
    const root = document.documentElement
    root.classList.remove('light')   // 공개 페이지 동안 다크 강제
    return () => {
      // 복원: 사용자의 실제 테마(기본=라이트). 명시적으로 다크를 고른 경우에만 다크 유지.
      if (useThemeStore.getState().mode === 'light') root.classList.add('light')
    }
  }, [])
  return null
}
